import {Injectable, signal, inject} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {environment} from '../../../../../environments/environment';
import {landAssetsStatusDataConstant} from '@app/features/assets-status/core/constants/land-assets-status.constant';
import {LandModel} from '@app/features/assets-status/core/models/land-table.model';

@Injectable({
  providedIn: 'root'
})
export class AssetsStatusService {
  assetTypeDetail = signal<any>({});
  landFormStorage = signal<any>(null);
  public readonly landsTable = signal<LandModel[]>(landAssetsStatusDataConstant as any);
  public readonly totalItems = signal(0)
  public readonly pageSize = signal(10);
  public readonly lastPage = signal(0);
  public readonly currentPage = signal(1);
  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);
  private apiUrl = environment.baseUrl;
  // convertLatLngToImage(lat: number, lng: number): Observable<Blob> {
  //   return this.http.get(
  //     `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=600x300&key=${environment.googleMapsApiKey}`,
  //     { responseType: 'blob' }  // مهم جدًا
  //   );
  // }

  getStaticMapImageUrl(lat: number, lng: number): SafeResourceUrl {
    // ✅ تأكد من وجود جميع المعاملات المطلوبة
    const url = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=600x300&maptype=roadmap&markers=color:red%7C${lat},${lng}&key=${environment.googleMapsApiKey}`;

    // console.log('Generated URL:', url); // للتأكد من الرابط
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  // Import lands data
  importLands(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/admin/lands/import`, formData);
  }

  // Create new land
  createLand(landData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/admin/lands`, landData);
  }

  // Get lands with pagination and filters
  getLandsTable(
    direction: string = 'ASC',
    search: string = '',
    page: number = 1,
    pageSize: number = 10
  ): void {
    let params = new HttpParams()
      .set('direction', direction)
      .set('search', search)
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    this.http.get(`${this.apiUrl}/admin/lands/table`, {params}).subscribe({
      next: (response: any) => {
        console.log(response.data.data);
        this.landsTable.set(response.data.data);
        this.totalItems.set(response.data.total);
        this.lastPage.set(Math.max(1, Math.ceil(this.totalItems() / this.pageSize())));

      }
    });
  }

  deleteLand(landId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/admin/lands/${landId}`);
  }

  bulkDeleteLands(ids: string[]): Observable<any> {
    return this.http.post(`${this.apiUrl}/admin/lands/bulk-delete`, {ids});
  }

  getLandLatLng(): Observable<any> {
    return this.http.get(`${this.apiUrl}/admin/lands/locations`);
  }

  getLandCategories(): Observable<any> {
    return this.http.get(`${this.apiUrl}/admin/facility-types`);
  }


  getMetroLines(): Observable<any> {
    return this.http.get(`/riyadh_metro.json`);
  }

  // Get land acquisition data (summary cards and charts)
  getLandAcquisitionData(): Observable<any> {
    return this.http.get(`${this.apiUrl}/admin/asset/land-acquisition-data`);
  }

  getRegions(): Observable<any> {
    return this.http.get(`${this.apiUrl}/admin/chart-parameters/regions`);
  }

  getCities(regionId: number): Observable<any> {
    let params = new HttpParams().set('region_id', regionId.toString());
    return this.http.get(`${this.apiUrl}/admin/transactions/cities-by-region`, {params});
  }

  getDistricts(cityId: number): Observable<any> {
    let params = new HttpParams().set('city_id', cityId.toString());
    return this.http.get(`${this.apiUrl}/admin/transactions/districts-by-city`, {params});
  }

  getTransactions(filters: any): Observable<any> {
    let params = new HttpParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        params = params.set(key, filters[key]);
      }
    });
    return this.http.get(`${this.apiUrl}/admin/transactions`, {params});
  }

  // Get market index data
  getMarketIndex(dateCategory: string = 'W'): Observable<any> {
    // return this.http.post(`${this.apiUrl}/admin/market-index`, { date_category: dateCategory });
    return this.http.get(`https://realestate-ai-backend-1073054914944.me-central2.run.app/get_market_index?date_category=${dateCategory}`);
  }

  getRealStateTypeCategory(): Observable<any> {
    return this.http.get(`${this.apiUrl}/admin/real-estate-type-categories`);
  }

  getRealStateTypeByCategoryId(categoryId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/admin/real-estate-type-categories/${categoryId}/real-estate-types`);
  }

  categoryFilterResult(land_id: number, category_id: number) {
    return this.http.get(`${this.apiUrl}/admin/lands/${land_id}/facilities/by-type/${category_id}`);
  }
}
